import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { mainNav } from '../../data/navigation';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'success'>('idle');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(/^\S+@\S+\.\S+$/.test(email) ? 'success' : 'error');
  };
  return <footer className="bg-ink text-canvas" data-id="element-175" data-mp="q2lbkabbzlp">
      <div className="mx-auto max-w-7xl px-5 pb-8 pt-14 lg:px-8" data-id="element-176" data-mp="3s2f2e01dtqnp">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between" data-id="element-177" data-mp="3s0uaki6gcltj">
          <div data-id="element-178" data-mp="3n17um0z8orh1">
            <p className="text-3xl font-semibold tracking-[0.32em]" data-id="element-179" data-mp="3j1yyipgq8hib">AMIRA</p>
            <p className="mt-2 text-sm text-canvas/50" data-id="element-180" data-mp="3izw3ts4mq079">Pure. Clear. Proven.</p>
          </div>

          <div className="w-full max-w-md" data-id="element-181" data-mp="3e4ytmhvm5kss">
            <p className="text-sm font-medium" data-id="element-182" data-mp="3939kx8vv5j7v">10% korting op je eerste bestelling</p>
            {status === 'success' ? <p className="mt-3 flex h-12 items-center gap-2 text-sm" role="status" data-id="element-183" data-mp="2kcbf1pvb8msl">
                <CheckIcon className="h-4 w-4 text-blush" data-id="element-184" data-mp="2p4v0ta45io8h" /> Check je inbox voor je code.
              </p> : <form onSubmit={submit} noValidate className="mt-3" data-id="element-185" data-mp="2bdzmvjespgy1">
                <label htmlFor="nl-email" className="sr-only" data-id="element-186" data-mp="2gaq1e2ayc4hc">E-mailadres</label>
                <div className="flex h-12 items-center rounded-full border border-canvas/20 pl-5 pr-1 focus-within:border-canvas" data-id="element-187" data-mp="340kg6peu0348">
                  <input id="nl-email" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                if (status === 'error') setStatus('idle');
              }} placeholder="jouw@email.nl" aria-invalid={status === 'error'} className="min-w-0 flex-1 bg-transparent text-sm text-canvas placeholder:text-canvas/40 focus:outline-none" data-id="element-188" data-mp="381e59m40fnyp" />
                  <button type="submit" className="grid h-10 w-10 place-items-center rounded-full bg-canvas text-ink transition-colors duration-150 hover:bg-blush" aria-label="Aanmelden" data-id="element-189" data-mp="zj4f9ne7czlr">
                    <ArrowRightIcon className="h-4 w-4" data-id="element-190" data-mp="uq2wv5esehxf" />
                  </button>
                </div>
                {status === 'error' && <p className="mt-2 text-xs text-blush" data-id="element-191" data-mp="kurhqlzgv8p5">Vul een geldig e-mailadres in.</p>}
              </form>}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-5 border-t border-canvas/10 pt-6 text-sm lg:flex-row lg:items-center lg:justify-between" data-id="element-192" data-mp="ftu1iey0ooqa">
          <nav aria-label="Footer" data-id="element-193" data-mp="6uqhn8r105aq">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-194" data-mp="6vs3m89kyc78">
              {[...mainNav, {
              to: '/over-amira',
              label: 'Over Amira'
            }].map(l => <li key={l.to} data-id="element-195" data-mp="218hyas7rvpfo">
                  <Link to={l.to} className="text-canvas/60 transition-colors duration-150 hover:text-canvas" data-id="element-196" data-mp="21888b4mq9i9z">{l.label}</Link>
                </li>)}
            </ul>
          </nav>
          <p className="text-canvas/40" data-id="element-197" data-mp="2dqbxrs1tgrfg">© 2026 AMIRA · iDEAL · Klarna · PayPal</p>
        </div>
      </div>
    </footer>;
}